<template>
	<v-dialog v-model="createInvoiceModal" transition="scroll-x-reverse-transition" max-width="500">
		<template #activator="{ on, attrs }">
			<v-btn
				rounded
				color="success"
				elevation="0"
				class="font-weight-bold"
				v-bind="attrs"
				v-on="on">
				<v-icon left>mdi-receipt-text-plus</v-icon>
				New Invoice
			</v-btn>
		</template>
		<template>
			<v-card>
				<v-card-title>
					<div>Create Invoice</div>
					<v-icon right class="ml-auto theme--dark" @click="createInvoiceModal = false">mdi-close</v-icon>
				</v-card-title>
				<v-divider class="mb-5" />
				<v-card-text>
					<div class="text-center">
						<p>Select how you'd like to start your invoice.</p>
					</div>
					<div class="d-flex text-center align-center justify-center">
						<v-btn
							color="success"
							elevation="2"
							large
							@click="createInvoice(false)">
							<v-icon left>mdi-receipt-text-plus</v-icon>
							Blank Invoice
						</v-btn>
						<div class="align-self-center mx-3 text-h6">or</div>
						<v-btn
							color="secondary"
							elevation="2"
							large
							@click="createInvoice(true)">
							<v-icon left>mdi-receipt-text-check</v-icon>
							Reports Invoice
						</v-btn>
					</div>
				</v-card-text>
			</v-card>
		</template>
	</v-dialog>
</template>
<script>
import Backend from '@/Layouts/Backend'

export default {
	components: {},
	layout: Backend,
	props: {
		project: {
			type: Object,
			required: true,
			default: null
		}
	},
	data () {
		return {
			createInvoiceModal: false
		}
	},
	mounted () {
		//
	},
	methods: {
		createInvoice (withReports = false) {
			const route = this.route('invoices.store', { project: this.project })
			this.$inertia.post(route, { reports: withReports }, {
				only: ['invoices', 'flash'],
				onFinish: () => this.createInvoiceModal = false
			})
		}
	}
}
</script>
